import axios from 'axios';

// Make testing/mocking easier by putting in separate file
export const httpClient = axios;
